import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { KeyValueBuilderComponentModule } from '@adaptiva/widgets/key-value-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { InstallTimePropertiesComponent } from './install-time-properties.component';

const WIDGETS: Type<any>[] = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	KeyValueBuilderComponentModule,
	TextComponentModule,
	ToggleSwitchComponent,
];

@NgModule({
	imports: [
		CommonModule,
		DisplayAuthoringPropertyPipe,
		IsRequiredPropertyPipe,
		InheritPipe,
		WIDGETS
	],
	declarations: [InstallTimePropertiesComponent],
	exports: [InstallTimePropertiesComponent]
})
export class InstallTimePropertiesComponentModule {

}
